import { getRequestContext } from "./requestContext.js";

type LogLevel = "debug" | "info" | "warn" | "error";

function prefix(): Record<string, unknown> {
  const ctx = getRequestContext();
  if (!ctx) return {};
  const meta: Record<string, unknown> = { path: ctx.path, ip: ctx.ip };
  if (ctx.userId !== undefined) meta.userId = ctx.userId;
  if (ctx.teamId !== undefined) meta.teamId = ctx.teamId;
  if (ctx.viewerId !== undefined) meta.viewerId = ctx.viewerId;
  return meta;
}

let stderrOnly = false;

export function useStderrOnly(): void {
  stderrOnly = true;
}

function emit(level: LogLevel, args: unknown[]): void {
  const meta = prefix();
  const target = stderrOnly
    ? console.error
    : level === "error"
      ? console.error
      : level === "warn"
        ? console.warn
        : level === "debug"
          ? console.debug
          : console.log;

  if (Object.keys(meta).length === 0) {
    target(...args);
  } else {
    target(meta, ...args);
  }
}

export const log = {
  debug: (...args: unknown[]) => emit("debug", args),
  info: (...args: unknown[]) => emit("info", args),
  warn: (...args: unknown[]) => emit("warn", args),
  error: (...args: unknown[]) => emit("error", args),
};
